export const ErrorHandler = (error) => {
  if (error.response.status == 400) {
    return error.response.data;
  } else {
    return "Something went wrong";
  }
};